import { MutationTree } from "vuex";
import { Log, LogLevel, LogState } from "@/services/logging/types";
import { shipLogs } from "@/services/logging/loggingService";

export const mutations: MutationTree<LogState> = {
    addLog(state, data: Log) {
        if (state.logLevels === "" ||
            !state.logLevels.includes(LogLevel[data.level])) {
            return;
        }

        state.logs.push(data);
    },
    async shipLogs(state) {
        if (state.logs.length === 0) {
            return;
        }
        const logs = state.logs;
        state.logs = [] as Log[];
        await shipLogs(logs);
    },
    updateLogLevels(state, logLevels: string) {
        state.logLevels = logLevels;
    }
};
